
import { useEffect, useRef } from 'react';
import SuccessStoryCard from './success-stories/SuccessStoryCard';
import CompaniesTicker from './success-stories/CompaniesTicker';

const successStories = [
  {
    logo: "/lovable-uploads/Fractal.png",
    highlight: "Made 12 offers in 2 months",
    description: "Staffed a critical client project within timelines"
  },
  {
    logo: "/lovable-uploads/StepSecurity.png",
    highlight: "Hired first candidate sourced on day 2",
    description: "Saved ₹2 Lakhs in agency fees"
  },
  {
    logo: "/lovable-uploads/Averlon.png",
    highlight: "Hired from first 5 candidates sourced",
    description: "Saved ₹1.2 Lakhs in agency fees"
  },
  {
    logo: "/lovable-uploads/CallHub.png",
    highlight: "Found a hidden candidate due to AI interviews",
    description: "At 40% of expected CTC"
  }
];

const SuccessStoriesSection = () => {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-white py-20 fade-in-section">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-cs-dark-grey mb-4">
            Successfully averted hiring emergencies at
          </h2>
          <p className="text-xl text-cs-medium-grey">
            Closed multiple positions with high speed and quality
          </p>
        </div>

        {/* Success Stories Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {successStories.map((story, index) => (
            <SuccessStoryCard
              key={index}
              logo={story.logo}
              highlight={story.highlight}
              description={story.description}
            />
          ))}
        </div>

        {/* Companies Ticker */}
        <CompaniesTicker />
      </div>
    </section>
  );
};

export default SuccessStoriesSection;
